export default __webpack_public_path__ + "static/2210-d3a148de408f08f03dbdd5a9389f210a.gif";